/* src\app.svelte generated by Svelte v3.55.1 */
import {
	SvelteComponent,
	check_outros,
	create_component,
	destroy_component,
	detach,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	safe_not_equal,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import { onDestroy, onMount } from '../_snowpack/pkg/svelte.js';
import { initializeApp } from "../_snowpack/pkg/firebase/app.js";
import { getAnalytics } from "../_snowpack/pkg/firebase/analytics.js";

import {
	getFirestore,
	setDoc,
	serverTimestamp,
	doc,
	collection
} from "../_snowpack/pkg/firebase/firestore.js";

import Kjells from './modules/kjells.svelte.js';
import { appSettings } from './appSettings.js';
import axios from '../_snowpack/pkg/axios.js';
import _ from '../_snowpack/pkg/lodash.js';

function create_if_block(ctx) {
	let kjells;
	let current;

	kjells = new Kjells({
			props: {
				fbApp: /*fbApp*/ ctx[2],
				products: /*products*/ ctx[3],
				formOnly: /*formOnly*/ ctx[0],
				saving: /*saving*/ ctx[4],
				noServiceLink: /*noServiceLink*/ ctx[1]
			}
		});

	kjells.$on("submit", /*submit_handler*/ ctx[12]);
	kjells.$on("discountCodeSelected", /*discountCodeSelected_handler*/ ctx[13]);
	kjells.$on("focus", /*focus_handler*/ ctx[14]);
	kjells.$on("changed", /*changed_handler*/ ctx[15]);
	kjells.$on("geolocation", /*geolocation_handler*/ ctx[16]);
	kjells.$on("dialogOpen", /*dialogOpen_handler*/ ctx[17]);
	kjells.$on("dialogClose", /*dialogClose_handler*/ ctx[18]);

	return {
		c() {
			create_component(kjells.$$.fragment);
		},
		m(target, anchor) {
			mount_component(kjells, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const kjells_changes = {};
			if (dirty[0] & /*fbApp*/ 4) kjells_changes.fbApp = /*fbApp*/ ctx[2];
			if (dirty[0] & /*products*/ 8) kjells_changes.products = /*products*/ ctx[3];
			if (dirty[0] & /*formOnly*/ 1) kjells_changes.formOnly = /*formOnly*/ ctx[0];
			if (dirty[0] & /*saving*/ 16) kjells_changes.saving = /*saving*/ ctx[4];
			if (dirty[0] & /*noServiceLink*/ 2) kjells_changes.noServiceLink = /*noServiceLink*/ ctx[1];
			kjells.$set(kjells_changes);
		},
		i(local) {
			if (current) return;
			transition_in(kjells.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(kjells.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(kjells, detaching);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*fbApp*/ ctx[2] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*fbApp*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty[0] & /*fbApp*/ 4) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function createGUID() {
	let dt = new Date().getTime();

	var uuid = ('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx').replace(/[xy]/g, function (c) {
		let r = (dt + Math.random() * 16) % 16 | 0;
		dt = Math.floor(dt / 16);
		return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
	});

	uuid = uuid.replace(/-/g, '');
	return uuid;
}

function instance($$self, $$props, $$invalidate) {
	let noThanks = false;
	let formOnly = false;
	let noServiceLink = false;
	let searchParams;
	let fbApp = null;
	let db = null;
	let clientInfo = null;
	let formData = null;
	let products = "Solskjerming,Garasjeport";
	let saving = false;

	//let discountCodes = [];
	//let listener;
	let selectedDiscountCode;

	let leadId = createGUID();
	let deviceId;
	let state = "NEW";

	const debounceOnFocusLog = _.debounce(
		docItem => {
			doLog(docItem);
		},
		1000,
		{ 'leading': false, 'trailing': true }
	);

	function doLog(docItem) {
		if (docItem) {
			docItem.lastUpdate = new Date().toISOString();
		}

		//console.log("docItem", "leads/customers/log", leadId, docItem);
		return setDoc(doc(collection(db, "leads/customers/log"), leadId), docItem, { merge: true });
	}

	function onfocus(e) {
		debounceOnFocusLog({ activeField: e.field });
	}

	function onFormChanged(e) {
		//console.log("form changed", e);
		if (state === "NEW") {
			state = "EDIT";
			doLog({ form: e, state: 'EDIT' });
		} else {
			doLog({ form: e });
		}
	}

	function onGeolocation(e) {
		doLog(e);
	}

	function onDialogOpen(e) {
		doLog({ dialogOpen: true });
	}

	function onDialogClose(e) {
		doLog({ dialogOpen: false });
	}

	async function onsubmit(data) {
		//console.log("Submit", data);
		$$invalidate(4, saving = true);

		let dt = serverTimestamp();
		let docId = leadId;

		let docItem = {
			id: docId,
			name: data.name,
			address: data.address,
			postalCode: data.postalCode,
			phoneNo: data.phoneNo.replace(/\s/g, ''),
			email: data.email,
			message: data.message,
			brand: "kjells",
			//state : 'CUSTOMERLEAD',
			created: dt,
			lastUpdate: dt,
			createdDate: new Date().toISOString(),
			isCompany: data.segment === 'bedrift',
			origin: 'customer', //origin: this.state.origin ? this.state.origin : 'customer',
			customerBrowserInfo: {
				appName: navigator.appName ? navigator.appName : null,
				appVersion: navigator.appVersion ? navigator.appVersion : null,
				appCodeName: navigator.appCodeName ? navigator.appCodeName : null,
				userAgent: navigator.userAgent ? navigator.userAgent : null,
				platform: navigator.platform ? navigator.platform : null
			}
		};

		if (docItem.isCompany) {
			docItem.state = 'NOT_ASSIGNED';
		} else {
			docItem.state = 'CUSTOMERLEAD';
		}

		if (isNaN(docItem.postalCode) === false) {
			docItem.postalCodeValue = parseInt(parseInt(data.postalCode));
		}

		let products = [];

		if (data.garasjeport) {
			products.push("Garasjeport");
		}

		if (data.solskjerming) {
			products.push("Solskjerming");
		}

		if (products.length > 0) {
			docItem.products = products;
		}

		if (clientInfo) {
			docItem.clientInfo = {};
			setClientInfoItem(docItem, "x-appengine-city");
			setClientInfoItem(docItem, "x-appengine-citylatlong");
			setClientInfoItem(docItem, "x-appengine-country");
			setClientInfoItem(docItem, "x-appengine-user-ip");
		}

		if (data.postalInfo) {
			docItem.postalArea = data.postalInfo.Poststed;
		}

		// if (searchParams.get('campaign')){
		//     docItem.campaign = searchParams.get('campaign');
		// }
		// if (searchParams.get('campaignUrl')){
		//     docItem.campaignUrl = searchParams.get('campaignUrl');
		// }
		if (searchParams.get('pageUrl')) {
			docItem.pageURL = searchParams.get('pageUrl');
		} else {
			if (window.document.referrer) {
				docItem.pageURL = window.document.referrer;
			} else {
				docItem.pageURL = "https://www.kjellsmarkiser.no";
			}
		}

		if (docItem.pageURL.includes("?")) {
			docItem.pageURL += '&leadId=' + docId;
		} else {
			docItem.pageURL += '?leadId=' + docId;
		}

		if (data.latitude && data.longitude) {
			docItem.latitude = data.latitude;
			docItem.longitude = data.longitude;
		}

		if (formData) {
			if (formData.formRaw) {
				docItem.formRaw = formData.formRaw;
			}

			let form = formData.form;

			if (form) {
				docItem.form = {};

				if (form.page !== undefined) {
					docItem.form.page = form.page;
				}

				if (form.originalReferer !== undefined) {
					docItem.form.originalReferer = form.originalReferer;
				}

				if (form.originalSearch !== undefined) {
					docItem.form.originalSearch = form.originalSearch;
				}
			}

			if (formData.formInfo) {
				docItem.formInfo = formData.formInfo;
			}
		}

		if (selectedDiscountCode) {
			docItem.discountCode = selectedDiscountCode.data.Code;
		}

		setDoc(doc(collection(db, "leads/customers/incoming"), docId), docItem).then(async () => {
			//console.log("New lead created...");
			if (selectedDiscountCode) {
				// Save DiscountCode details at /leads/customers/discountCodes
				let discountCodeItem = {
					leadId: docId,
					discountCode: selectedDiscountCode.data.Code,
					terms: selectedDiscountCode.data.Terms,
					validFrom: selectedDiscountCode.data.ValidFrom,
					validTo: selectedDiscountCode.data.ValidTo,
					created: new Date().toISOString()
				};

				//console.log("discountCodeItem", discountCodeItem);
				setDoc(doc(collection(db, "leads/customers/discountCodes"), docId), discountCodeItem).then(async () => {
					//console.log("Set Doc", docItem);
					await doLog({ state: 'SUBMITTED' });

					if (noThanks === false) {
						redirectOnCreateLead();
					} else {
						if (window.parent) {
							console.log("Sending lead created event...");

							window.parent.postMessage(
								JSON.stringify({
									event: 'leadCreated',
									timestamp: new Date().toISOString(),
									lead: docItem
								}),
								'*'
							);
						}

						$$invalidate(4, saving = false);
					}
				});
			} else {
				await doLog({ state: 'SUBMITTED' });

				if (noThanks === false) {
					redirectOnCreateLead();
				} else {
					if (window.parent) {
						console.log("Sending lead created event...");

						window.parent.postMessage(
							JSON.stringify({
								event: 'leadCreated',
								timestamp: new Date().toISOString(),
								lead: docItem
							}),
							'*'
						);
					}

					$$invalidate(4, saving = false);
				}
			}
		}).catch(error => {
			console.log("Error creating new lead: ", error);
			$$invalidate(4, saving = false);
		});
	}

	function redirectOnCreateLead() {
		if (noThanks === false) {
			if (window.location !== window.parent.location) {
				window.parent.location = appSettings.thankYouUrl;
			} else {
				window.location.href = appSettings.thankYouUrl;
			}
		}
	}

	function setClientInfoItem(docItem, name) {
		if (clientInfo[name]) {
			docItem.clientInfo[name] = clientInfo[name];
		}
	}

	onMount(async () => {
		window.addEventListener("message", onMessage);
		searchParams = new URLSearchParams(window.location.search);
		noThanks = searchParams.get('noThanks') === 'true';
		$$invalidate(0, formOnly = searchParams.get('formOnly') === 'true');
		$$invalidate(1, noServiceLink = searchParams.get('noServiceLink') === 'true');
		$$invalidate(3, products = searchParams.get('products') || "Solskjerming,Garasjeport");
		let firebaseConfig = appSettings.firebaseConfig;

		if (firebaseConfig) {
			$$invalidate(2, fbApp = initializeApp(firebaseConfig));
			getAnalytics(fbApp);
			db = getFirestore(fbApp);
		}

		let logItem = { state: 'NEW', leadId };
		deviceId = localStorage.getItem("HDSAppsDeviceId");

		if (!deviceId) {
			try {
				deviceId = createGUID();
				localStorage.setItem("HDSAppsDeviceId", deviceId);
			} catch(err) {
				console.log("unable to create deviceId");
			}
		}

		logItem.deviceId = deviceId;
		logItem.origin = "customer";
		logItem.createdDate = new Date().toISOString();
		logItem.brand = "kjells";

		logItem.customerBrowserInfo = {
			appName: navigator.appName ? navigator.appName : null,
			appVersion: navigator.appVersion ? navigator.appVersion : null,
			appCodeName: navigator.appCodeName ? navigator.appCodeName : null,
			userAgent: navigator.userAgent ? navigator.userAgent : null,
			platform: navigator.platform ? navigator.platform : null
		};

		doLog(logItem);

		try {
			axios.get(appSettings.clientInfoUrl).then(result => {
				clientInfo = result.data;
				doLog({ clientInfo });
			}).catch(err => {
				console.log("clientInfo Error", err);
			});
		} catch(err) {
			
		}

		// Handle search parameters
		handleSearchParams();
	});

	function handleSearchParams() {
		//console.log("handleSearchParams", window.location.search);
		if (window.location.search) {
			formData = {};
			let originalSearch = window.location.search;
			let formInfo = {};

			if (originalSearch && originalSearch.indexOf('?') === 0) {
				originalSearch = originalSearch.replace("?", "");
				let searchItems = originalSearch.split('&');

				//console.log("searchItems", searchItems);
				if (searchItems.length > 0) {
					formInfo.originalSearch = {};

					searchItems.forEach(search => {
						if (search && search !== "" && search.indexOf('=') > -1) {
							let item = search.split('=');
							formInfo.originalSearch[item[0]] = item[1];
						}
					});

					// Remove elements having undefined values, if any
					Object.keys(formInfo.originalSearch).forEach(key => {
						if (formInfo.originalSearch[key] === undefined) {
							delete formInfo.originalSearch[key];
						}
					});
				}

				//console.log("formInfo", formInfo);
				if (Object.keys(formInfo).length > 0) {
					//console.log("append form Info ");
					formData.formInfo = formInfo;
				}

				doLog({ formInfo: formData.formInfo });
			}
		}
	} //console.log("formData", formData);

	function onMessage(event) {
		try {
			console.log("onMessage", event);
			let form = JSON.parse(event.data);

			//console.log("FORM", this);
			if (form) {
				if (form.page || form.originalSearch) {
					formData = { form, formRaw: event.data };

					if (form.originalSearch) {
						let originalSearch = form.originalSearch;
						let formInfo = {};

						if (originalSearch && originalSearch.indexOf('?') === 0) {
							originalSearch = originalSearch.replace("?", "");
							let searchItems = originalSearch.split('&');

							//console.log("searchItems", searchItems);
							if (searchItems.length > 0) {
								formInfo.originalSearch = {};

								searchItems.forEach(search => {
									if (search && search !== "" && search.indexOf('=') > -1) {
										let item = search.split('=');
										formInfo.originalSearch[item[0]] = item[1];
									}
								});

								// Remove elements having undefined values, if any
								Object.keys(formInfo.originalSearch).forEach(key => {
									if (formInfo.originalSearch[key] === undefined) {
										delete formInfo.originalSearch[key];
									}
								});
							}
						} //console.log("formInfo", formInfo);

						if (Object.keys(formInfo).length > 0) {
							//console.log("append form Info ");
							formData.formInfo = formInfo;
						}

						doLog({ formInfo: formData.formInfo });
					}
				}
			}
		} catch(exc) {
			console.log("Error...");
		}
	}

	onDestroy(() => {
		window.removeEventListener("message", onMessage, false);
	}); // if (listener){
	//     console.log("Remove listener...");
	//     listener();
	// }

	const submit_handler = e => onsubmit(e.detail);

	const discountCodeSelected_handler = e => {
		$$invalidate(5, selectedDiscountCode = e.detail);
	};

	const focus_handler = e => {
		onfocus(e.detail);
	};

	const changed_handler = e => {
		onFormChanged(e.detail);
	};

	const geolocation_handler = e => {
		onGeolocation(e.detail);
	};

	const dialogOpen_handler = e => onDialogOpen(e.detail);
	const dialogClose_handler = e => onDialogClose(e.detail);

	return [
		formOnly,
		noServiceLink,
		fbApp,
		products,
		saving,
		selectedDiscountCode,
		onfocus,
		onFormChanged,
		onGeolocation,
		onDialogOpen,
		onDialogClose,
		onsubmit,
		submit_handler,
		discountCodeSelected_handler,
		focus_handler,
		changed_handler,
		geolocation_handler,
		dialogOpen_handler,
		dialogClose_handler
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {}, null, [-1, -1]);
	}
}

export default App;